import VSlideGroup from './VSlideGroup'
import VSlideItem from './VSlideItem'

export {
  VSlideGroup,
  VSlideItem,
}

export default {
  $_ifrontui_subcomponents: {
    VSlideGroup,
    VSlideItem,
  },
}
